import { TFooterProps } from "@/app/actions/get-home";
import Link from "next/link";
import { Icon } from "../icon";

type TStoreButtonsProps = {
  data: TFooterProps["redes"];
};

export function SocialLinks({ data }: TStoreButtonsProps) {
  return (
    <ul className="flex gap-4 text-4xl flex-wrap md:flex-nowrap justify-center items-center w-fit">
      {data?.map((item) => (
        <li key={item.titulo}>
          <Link href={item.url || ""}>
            <Icon
              icon={item.icone!}
              size={24}
              className="hover:drop-shadow-2xl hover:text-primary scale-100 hover:scale-110 transition-all duration-300"
            />
          </Link>
        </li>
      ))}
    </ul>
  );
}
